import React from "react"
import PropTypes from "prop-types"
import { SelectTree } from "@tencent/spaui-business"
import { withApi } from "@tencent/react-aio"
import { connect } from "react-redux"
import _ from "lodash"
import * as ActionTypes from "@/stores/sale/actions"
import MessageBox from "@/components/MessageBox"

class EmployeeTeamSelect extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    value: PropTypes.number,
    organizationTree: PropTypes.object,
    onChange: PropTypes.func,
  }

  state = {
    employeeWorkingTeams: undefined,
  }

  componentDidMount() {
    const { webApi, ownerId, defaultValue, value, getFirstTeamId } = this.props
    if (_.isEmpty(ownerId)) {
      webApi
        .getEmployeeWorkingTeams(ownerId)
        .ajax()
        .then(
          (res) => {
            this.setState({
              employeeWorkingTeams: res,
            })
            if (defaultValue && !value) {
              this.setState({ teamId: res[0]?.teamId })
              // 通过回调返回数据第一项teamId
              getFirstTeamId && getFirstTeamId(res[0]?.teamId)
            }
          },
          (err) => {
            this.context.error("获取所属团队列表失败", err.message)
          }
        )
    }
  }

  render() {
    const { employeeWorkingTeams, teamId } = this.state
    let { value, onChange, defaultValue = false } = this.props
    let fieldNames = {
      labelFieldName: "name",
      titleFieldName: "tips",
      nodeFieldName: "children",
      valueFieldName: "teamId",
      disabledFieldName: "disabled",
    }

    if (!value && defaultValue) {
      value = teamId
    }

    if (!value && employeeWorkingTeams && employeeWorkingTeams.length === 1) {
      // 如果不是编辑页面，且雇员只有一个所属团队，则默认选择该团队
      const teamId = employeeWorkingTeams[0].teamId
      this.props.setTeamId(teamId)
      return <SelectTree TreeProps={{ unrelated: true }} fieldNames={fieldNames} showParentNodeLabel={false} data={employeeWorkingTeams || []} value={employeeWorkingTeams[0].teamId || []} onChange={onChange} />
    }
    return <SelectTree TreeProps={{ unrelated: true }} fieldNames={fieldNames} showParentNodeLabel={false} data={employeeWorkingTeams || []} value={value || []} onChange={onChange} />
  }
}

function mapStateToProps(state, ownProps) {
  return {
    employeeWorkingTeams: state.employeeWorkingTeams,
  }
}

export default withApi(connect(mapStateToProps)(EmployeeTeamSelect))

EmployeeTeamSelect.contextType = MessageBox
